module.exports = __webpack_public_path__ + "img/充电桩概览.1653a7b2.png";